var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCoupon = function SvgIconCoupon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 182,
    viewBox: "0 0 208 182",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9495",
    "data-name": "Grupo 9495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5537",
    "data-name": "Caminho 5537",
    d: "M178.54,35.183,164.728,11.128a9.181,9.181,0,0,0-12.579-3.385L8.606,91.057A9.283,9.283,0,0,0,5.236,103.7l13.811,24.05a18.36,18.36,0,0,1,25.158,6.776,18.564,18.564,0,0,1-6.745,25.288l13.811,24.055a9.181,9.181,0,0,0,12.579,3.385L207.4,103.943a9.283,9.283,0,0,0,3.37-12.646l-13.812-24.05A18.36,18.36,0,0,1,171.8,60.471,18.564,18.564,0,0,1,178.54,35.183ZM192.793,78.52l10,17.41-31.9,18.512-2.3-4.009a4.591,4.591,0,0,0-6.287-1.7,4.645,4.645,0,0,0-1.69,6.323l2.3,4.009L59.249,179.239l-9.995-17.4A27.945,27.945,0,0,0,52.177,129.9a27.617,27.617,0,0,0-28.97-13.421l-10-17.41L116.877,38.9l2.3,4.009a4.591,4.591,0,0,0,6.287,1.7,4.639,4.639,0,0,0,1.685-6.323l-2.3-4.009,31.9-18.512,9.995,17.4A27.936,27.936,0,0,0,163.824,65.1,27.617,27.617,0,0,0,192.793,78.52Z",
    transform: "translate(-4 -6.5)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5538",
    "data-name": "Caminho 5538",
    d: "M33.216,21.263a4.606,4.606,0,0,0-1.692,6.3l4.623,7.995a4.623,4.623,0,0,0,8.013-4.614l-4.628-7.995A4.63,4.63,0,0,0,33.216,21.263Z",
    transform: "translate(108.939 52.936)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5539",
    "data-name": "Caminho 5539",
    d: "M30.117,15.867a4.606,4.606,0,0,0-1.692,6.3l4.623,7.995a4.623,4.623,0,0,0,8.013-4.614l-4.628-7.995A4.63,4.63,0,0,0,30.117,15.867Z",
    transform: "translate(95.929 30.264)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5540",
    "data-name": "Caminho 5540",
    d: "M24.675,19.1a4.621,4.621,0,0,0-4.628,4.614v60a4.625,4.625,0,0,0,9.251,0v-60A4.62,4.62,0,0,0,24.675,19.1Z",
    transform: "translate(63.38 46.557)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5541",
    "data-name": "Caminho 5541",
    d: "M41.478,33.333l-2.314-4A13.865,13.865,0,0,0,15.136,43.179l2.309,4A13.868,13.868,0,0,0,41.478,33.333Zm-8.013,4.614a4.621,4.621,0,0,1-8.008,4.614l-2.314-4a4.623,4.623,0,0,1,8.013-4.614Z",
    transform: "translate(34.926 60.395)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5542",
    "data-name": "Caminho 5542",
    d: "M29.769,24.887A13.843,13.843,0,0,0,24.692,43.8l2.314,4A13.867,13.867,0,0,0,51.034,33.949l-2.314-4A13.9,13.9,0,0,0,29.769,24.887ZM43.027,38.564a4.625,4.625,0,0,1-8.013,4.619l-2.314-4a4.623,4.623,0,0,1,8.013-4.614Z",
    transform: "translate(75.03 63)",
    fill: "#191750"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCoupon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_coupon.ff6f098f.svg";
export { ForwardRef as ReactComponent };